import { render, staticRenderFns } from "./CustomRatingTable.vue?vue&type=template&id=5a885c84&"
import script from "./CustomRatingTable.vue?vue&type=script&lang=js&"
export * from "./CustomRatingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports